"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
var _defineProperty2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _zhjySerach = _interopRequireDefault(require("@/components/search/zhjySerach.vue"));
var _funBtn = _interopRequireDefault(require("@/components/funBtn/funBtn.vue"));
var _zhjyTable = _interopRequireDefault(require("@/components/table/zhjyTable.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
var _school = require("@/api/school/school");
var _index = _interopRequireDefault(require("@/components/excelDia/index.vue"));
var _vuex = require("vuex");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  computed: _objectSpread({}, (0, _vuex.mapState)({
    userInfo: function userInfo(state) {
      return state.user.userInfo;
    }
  })),
  data: function data() {
    return {
      queryGroup: [{
        label: "精确查找",
        type: "input",
        model: "queryValue",
        placeholder: "名称/编码"
      }],
      modelData: {
        queryValue: ""
      },
      defaultColumn: [{
        name: "名称",
        prop: "name",
        isShow: true,
        width: "200"
      }, {
        name: "编码",
        prop: "uniqueCode",
        isShow: true,
        width: "100"
      }, {
        name: "院校类型",
        prop: "type",
        isShow: true,
        width: "100"
      }, {
        name: "创建时间",
        prop: "createTime",
        isShow: true,
        width: "200",
        sortable: true
      }, {
        name: "更新时间",
        prop: "updateTime",
        isShow: true,
        width: "200",
        sortable: true
      }],
      funBtns: [
      // {
      //   size: "small",
      //   click: "morePublishout",
      //   icon: "iconfont icon-daochuExcel",
      //   name: "导出",
      //   type: "primary",
      // },
      {
        size: "small",
        click: "excelIn",
        icon: "iconfont icon-Excledaoru",
        name: "导入",
        type: "primary"
      },
      // {
      //   size: "small",
      //   click: "deleteById",
      //   icon: "el-icon-delete",
      //   name: "批量删除",
      //   type: "danger"
      // },
      {
        size: "small",
        click: "save",
        icon: "el-icon-circle-plus-outline",
        name: "新增",
        type: "primary"
      }],
      minWidth: 300,
      page: {
        pageNumber: 1,
        pageSize: 10
      },
      totalData: 0,
      listData: [],
      options: [{
        name: "编辑",
        class: "edit",
        option: "edit",
        span: 3
      }, {
        name: "查看管理员",
        class: "editor",
        option: "viewAdmin",
        span: 5
      }
      // { name: "删除", class: "delet", option: "deleteById", span: 3 }
      ],
      formatters: {
        belongAdministrator: []
      },
      sort: {
        prop: "",
        order: ""
      },
      school: {
        bureauId: "",
        queryValue: "",
        type: 0
      },
      idList: [],
      checkBoxList: [],
      checkBoxs: [],
      // 文本信息
      textInfo: {
        title: "Excel导入学校信息",
        info: "学校信息",
        url: "bureau/import",
        code: "https://file.icve.com.cn/ssykt/907/575/E2D8FFE53673080C98FB349B27D74A59.xlsx"
      }
    };
  },
  methods: {
    // 导入学校
    excelIn: function excelIn() {
      this.$refs.dialogVal.changShow();
    },
    // 获取学校列表
    getSchool: function getSchool() {
      var _this = this;
      (0, _school.schoolList)({
        bureauId: this.userInfo.cityId,
        queryValue: this.school.queryValue,
        type: this.school.type,
        pageSize: this.page.pageSize,
        pageNum: this.page.pageNumber
      }).then(function (res) {
        var data = res.data;
        data.list.forEach(function (item) {
          if (item.type === 1) {
            item.type = "中职";
          } else if (item.type === 2) {
            item.type = "高职";
          } else if (item.type === 3) {
            item.type = "本科";
          }
        });
        _this.totalData = data.total;
        _this.listData = data.list;
      });
    },
    search: function search(val) {
      this.school.queryValue = val.queryValue;
      this.getSchool();
    },
    morePublishout: function morePublishout() {},
    morePublish: function morePublish() {},
    dels: function dels() {},
    // 新增
    save: function save() {
      this.$router.push({
        path: "/schoolTest/school-add",
        query: {
          id: this.$store.state.user.userInfo.cityId
        }
      });
    },
    // 删除
    deleteById: function deleteById(row) {
      var _this2 = this;
      var id = [];
      if (!row && this.checkBoxs.length === 0) {
        return this.$message.error("请先勾选数据");
      } else if (row) {
        id.push(row.id);
      } else if (this.checkBoxs.length > 0) {
        id = this.checkBoxs;
      }
      this.$confirm("确认删除吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      }).then(function () {
        (0, _school.schoolMove)({
          idList: id
        }).then(function (res) {
          _this2.$message.success("删除成功。");
          _this2.getSchool();
        });
      }).catch(function () {
        _this2.$message.info("取消删除。");
      });
    },
    // 编辑按钮
    edit: function edit(row) {
      this.$router.push({
        path: "/schoolTest/school-edit",
        query: {
          id: row.id
        }
      });
    },
    // 查看管理员
    viewAdmin: function viewAdmin(row) {
      console.log(row, "xx");
      this.$router.push({
        path: "/schoolTest/school-view",
        query: {
          id: row.id,
          title: row.name
        }
      });
    },
    // 下载导入结果
    downExcel: function downExcel(e, j) {
      // if (e) {
      //   request({
      //     url: "excelTest/downExcelFile",
      //     type: "exportExcel",
      //     data: {
      //       name: e,
      //     },
      //   }).then((res) => {
      //       this.commonJs.download(res.data, j);
      //   });
      // }
    },
    handleSelectionChange: function handleSelectionChange(row) {
      var _this3 = this;
      this.checkBoxs = [];
      row.forEach(function (item) {
        _this3.checkBoxs.push(item.id);
      });
    },
    distribution: function distribution() {},
    sortChange: function sortChange() {},
    handleCurrentChange: function handleCurrentChange(e) {
      this.page.pageNumber = e;
      this.getSchool();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNumber = 1;
      this.getSchool();
    }
  },
  created: function created() {
    this.getSchool();
  },
  components: {
    ZhjySerach: _zhjySerach.default,
    ZhjyPagination: _zhjyPagination.default,
    FunBtn: _funBtn.default,
    ZhjyTable: _zhjyTable.default,
    ExcelDig: _index.default
  }
};